import { DeputateIcon, LockIcon, ProfileIcon, SettingsIcon, SubstitutionsIcon, TimetableIcon } from '@bp/ui-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../components/Page/Page';
import { useAuthClaims } from '../../hooks/useAuthClaims';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';

export const Dashboard: FC = () => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const permissions = usePermissionChecker();
  const navigate = useNavigate();

  const organizeColumns = [
    permissions?.canReadDeputate(),
    permissions?.canReadTimetable(),
    permissions?.canManageSubstitution(),
  ].filter(Boolean).length;

  const maintainColumns =
    [permissions?.canManageSettings(), permissions?.canManageAdministration()].filter(Boolean).length + 1; // +1 for profile

  return (
    <Page
      isForbidden={false}
      title={t('dashboard.salutation', {
        name: pimAuthClaims.getProfile()?.displayName,
      })}
    >
      <IconMenu headline={t('dashboard.organize')} columns={organizeColumns || undefined}>
        {permissions?.canReadDeputate() && (
          <IconMenuItem
            label={t('deputate.title', { count: 2 })}
            icon={<DeputateIcon />}
            bubbleType={5}
            onClick={() => navigate(t('routes.deputate.slug'))}
          />
        )}
        {permissions?.canReadTimetable() && (
          <IconMenuItem
            label={t('timetable.title', { count: 2 })}
            icon={<TimetableIcon />}
            bubbleType={6}
            onClick={() => navigate(t('routes.timetable.slug'))}
          />
        )}
        {permissions?.canManageSubstitution() && (
          <IconMenuItem
            label={t(`substitutions.title`, { count: 2 })}
            icon={<SubstitutionsIcon />}
            bubbleType={7}
            onClick={() => navigate(t('routes.substitutions.slug'))}
          />
        )}
      </IconMenu>

      <IconMenu headline={t('dashboard.maintain')} hasMarginTop columns={maintainColumns}>
        {permissions?.canManageSettings() && (
          <IconMenuItem
            label={t('settings.title', { count: 2 })}
            icon={<SettingsIcon />}
            bubbleType={8}
            onClick={() => navigate(t('routes.settings.slug'))}
          />
        )}
        {permissions?.canManageAdministration() && (
          <IconMenuItem
            label={t('routes.admin.title')}
            icon={<LockIcon />}
            bubbleType={9}
            onClick={() => navigate(t('routes.admin.slug'))}
          />
        )}
        <IconMenuItem
          label={t('profile.title', { count: 1 })}
          icon={<ProfileIcon />}
          bubbleType={12}
          onClick={() => navigate(t('routes.profile.slug'))}
        />
      </IconMenu>
    </Page>
  );
};
